import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationService } from 'src/app/services/application.service';
import { Router } from '@angular/router';
import { BrandSelectorLogo } from 'src/app/interfaces/brand-selector-logo';
import { SearchService } from 'src/app/services/search.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: "app-partner-portal-info-blocks",
    imports: [CommonModule, TranslateModule],
    templateUrl: "./partner-portal-info-blocks.component.html",
    styleUrls: ["./partner-portal-info-blocks.component.scss"]
})
export class PartnerPortalInfoBlocksComponent implements OnInit {
  selectedCompanyGroup: string;
  selectLanguage: any;
  logos: BrandSelectorLogo[];

  constructor(
    private applicationService: ApplicationService,
    private searchService: SearchService,
    private router: Router
  ) {}

  ngOnInit() {
    this.selectedCompanyGroup =
      this.applicationService.getSelectCompanyGroupCode();
    this.selectLanguage = this.applicationService.getSelectedLanguage();    
    this.getLogos();
  }

  getLogos() {
    this.logos = this.applicationService.getSelectedCompanyGroupBrands(
      this.applicationService.getSelectCompanyGroupCode()
    ).filter((b) => {
      const brand = b as BrandSelectorLogo;
      return brand.bike_count > 0 || brand.type === "parts";
    })
  }

  gotoSearch(brand: any) {
    this.searchService.setBrandAndArticleType([brand.name], brand.type);
    this.searchService.emitChange("");

    this.router.navigateByUrl(
      `${this.applicationService.getSelectCompanyGroupCode()}/search#filter&brands=${brand.name}&article_type=${brand.type}`
    );
  }
}
